import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Pages
import Home from './pages/Home';
import Standings from './pages/Standings';
import Rounds from './pages/Rounds';
import AddRound from './pages/AddRound';
import AddPlayer from './pages/AddPlayer';
import AddCourse from './pages/AddCourse';
import Players from './pages/Players';
import NotFound from './pages/NotFound';

function App() {
  const [theme, setTheme] = useState('dark');

  // Load saved theme on first render
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    if (savedTheme === 'light') {
      document.body.classList.add('light-mode');
      setTheme('light');
    } else {
      document.body.classList.remove('light-mode');
      setTheme('dark');
    }
  }, []);

  // Toggle theme function
  const toggleTheme = () => {
    if (theme === 'dark') {
      document.body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
      setTheme('light');
    } else {
      document.body.classList.remove('light-mode');
      localStorage.setItem('theme', 'dark');
      setTheme('dark');
    }
  };

  return (
    <Router>
      <div className="app">
        <Header toggleTheme={toggleTheme} theme={theme} />
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/standings" element={<Standings />} />
            <Route path="/rounds" element={<Rounds />} />
            <Route path="/add-round" element={<AddRound />} />
            <Route path="/add-player" element={<AddPlayer />} />
            <Route path="/add-course" element={<AddCourse />} />
            <Route path="/players" element={<Players />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App; 